<template>
  <v-row class="d-flex justify-center">
    <v-col cols="auto" class="pr-3 text-center mt-9">
      <QuotationStatusMessage :title="message" text="" />
    </v-col>
  </v-row>
</template>
<script>
import QuotationStatusMessage from "./QuotationStatusMessage.vue";
export default {
  name: "QuotationProposalAwaitingMessage",
  components: { QuotationStatusMessage },
  props: {
    message: {
      type: String,
      default:
        "Obrigado, estamos efetivando sua proposta. O prazo de retorno é de até 1 dia útil."
    }
  }
};
</script>
